/** @format */

import React from 'react';

import {GridSelect, IconButton, Popover} from '@sttark/design-system';
import {
    LAMINATES,
    LAMINATE_NO_LAMINATE,
    SUBSTRATES_IMAGE_GROUP,
    LAMINATE_HOLO,
    LAMINATE_LEATHER,
    SUBSTRATE_RAINBOW_HOLOGRAM_PLASTIC,
    SUBSTRATE_SILVER_METALLIC_PLASTIC
} from 'frontier-constants';
import {OptionDescription} from 'frontier/ds/quoter/laminate_material_select_descriptions';

export default function LaminateSelect({value, onChange, substrate}) {
    let laminates;
    // Filter out leather laminate for labels and no laminate option
    laminates = LAMINATES.filter(l => l.id !== LAMINATE_NO_LAMINATE && l.id !== LAMINATE_LEATHER);
    if (parseInt(substrate) === SUBSTRATE_RAINBOW_HOLOGRAM_PLASTIC) {
        laminates = LAMINATES.filter(
            l =>
                l.id !== LAMINATE_HOLO && l.id !== LAMINATE_NO_LAMINATE && l.id !== LAMINATE_LEATHER
        );
    }
    if (parseInt(substrate) === SUBSTRATE_SILVER_METALLIC_PLASTIC) {
        laminates = LAMINATES.filter(
            l =>
                l.id !== LAMINATE_HOLO && l.id !== LAMINATE_NO_LAMINATE && l.id !== LAMINATE_LEATHER
        );
    }
    if (substrate) {
        return (
            <GridSelect
                options={laminates.map(l => ({
                    label: l.label,
                    value: l.id,
                    image:
                        '/assets/images/quoter/laminate/' +
                        SUBSTRATES_IMAGE_GROUP.find(({id}) => id === parseInt(substrate)).group +
                        '/' +
                        l.image,
                    hoverImage:
                        '/assets/images/quoter/laminate/' +
                        SUBSTRATES_IMAGE_GROUP.find(({id}) => id === parseInt(substrate)).group +
                        '/' +
                        l.hoverImage,
                    description: <OptionDescription option={l} className="laminate-select-label" />
                }))}
                ratio="1x1"
                value={value}
                minCols={3}
                onChange={onChange}
                maxCols={3}
            />
        );
    } else {
        return null;
    }
}
